import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SurveyContext } from "../../store/survey-context";
import { currentPageIndex, setAppBackground } from "../../utils";
import Cta from "../cta/Cta";
import "./splashScreen.scss";
// import Button from "../../components/button/Button"

export default function SplashScreen(props) {
  const { currentChapterNumber, survey, setSplash, toggleSurvey } =
    useContext(SurveyContext);
  const { setLastVisitedPage } = props;
  const { t } = useTranslation(["common", "survey"]);
  const currentChapterLabel = t(
    `survey.chapters.ch_${currentChapterNumber}.label`,
    { ns: "survey" }
  );
  const currentChapterName = t(
    `survey.chapters.ch_${currentChapterNumber}.name`,
    { ns: "survey" }
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    //console.log('questionnaire/chapter/' + context.currentChapterNumber);
    setLastVisitedPage(-1);
    setAppBackground(`C${currentChapterNumber}-1b.png`);

    if (window.hj) {
      window.hj("stateChange", "questionnaire/chapter/" + currentChapterNumber);
    }
    return function cleanup() {
      setTimeout(() => {
        if (window.hj && survey && !document.querySelector(".navigation")) {
          const stepNew =
            survey.pages.findIndex(
              (element) => element.name === survey.currentPage?.name
            ) + 1;
          //console.log('splash - umount questionnaire/'+stepNew);
          window.hj("stateChange", "questionnaire/" + stepNew);
        }
      }, 50);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };
  }, [currentChapterNumber, survey, setLastVisitedPage]);

  const hideSplashHandler = () => {
    props.setLastVisitedPage(currentPageIndex(survey));
    setSplash(false);
    setAppBackground(`C${currentChapterNumber}-2b.png`, 0.8);
  };

  const goBack = () => {
    setSplash(false);
    toggleSurvey(false);
  };

  const desc = t(`survey.chapters.ch_${currentChapterNumber}.landing`, {
    ns: "survey",
  });

  return (
    <div className="container">
      <div className="splashScreen">
        <div className="splashScreen__header">
          <span className="splashScreen__chapter">{currentChapterLabel}</span>
          <h1 className="headline--secondary text-uppercase">
            {" "}
            {currentChapterName}
          </h1>
        </div>
        <p className="splashScreen__paragraph">{desc}</p>
        <div className="action-bar splashScreen__action-bar flex-center">
          <Cta
            ctaClass="cta--secondary cta--centered next"
            tagName="button"
            onClick={goBack}
          >
            {t("button.go_back")}
          </Cta>
          <Cta
            ctaClass="cta--primary cta--centered next"
            tagName="button"
            onClick={hideSplashHandler}
          >
            {t("button.enter")}
          </Cta>
        </div>
      </div>
    </div>
  );
}
